import { useMemo } from 'react';
import { useLocation } from 'react-router';
import qs from 'qs';

export default function useQueryParams () {
  const location = useLocation();
  const queryParams = useMemo(() => qs.parse(decodeURI(location.search.slice(1))), [location]);
  return queryParams;
};
